import { Injectable } from '@angular/core';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { AppInfoConfig } from '../client-config/app-info.client-config';
import { ClientConfigService } from '../client-config/client-config.service';
import { DslService } from '../dsl/dsl.service';
import { UrlService } from '../navigation/url.service';
import { ProductService } from '../products/product.service';
import { SpeculationDetectionService } from '../speculation-detection/speculation-detection.service';
import { LastKnownProductConfig } from './last-known-product.client-config';
import { LastKnownProductService } from './last-known-product.service';

@Injectable()
export class LastKnownProductBootstrapService implements OnAppInit {
    constructor(
        private config: LastKnownProductConfig,
        private dslService: DslService,
        private lastKnownProductService: LastKnownProductService,
        private appInfoConfig: AppInfoConfig,
        private speculationDetectionService: SpeculationDetectionService,
        private productService: ProductService,
        private clientConfigService: ClientConfigService,
        private urlService: UrlService,
    ) {}

    onAppInit() {
        if (this.speculationDetectionService.isPrerendering()) {
            this.speculationDetectionService.prerenderActivate$.subscribe(() => this.bootstrap());

            return;
        }

        this.bootstrap();
    }

    private bootstrap() {
        this.dslService.evaluateExpression<boolean>(this.config.enabled).subscribe((isEnabled) => {
            if (!isEnabled) return;

            const lastProduct = this.lastKnownProductService.get();
            const isSingleDomain = this.productService.isSingleDomainApp;
            const currentUrl = this.urlService.current();

            const productName = isSingleDomain ? this.productService.current.name : this.config.product;

            const productPath = isSingleDomain ? this.clientConfigService.getProductPath(productName)?.toLowerCase() : null;

            const fullUrl = isSingleDomain ? `${currentUrl.baseUrl()}/${currentUrl.culture}${productPath ? `/${productPath}` : ''}` : this.config.url;

            const isNewProduct = lastProduct.name !== productName;
            const isNewUrl = lastProduct.url !== fullUrl;

            if (isNewProduct || isNewUrl) {
                this.lastKnownProductService.add({
                    url: fullUrl,
                    name: productName === 'host' ? this.lastKnownProductService.UNKNOWN : productName,
                    previous: isNewProduct ? lastProduct.name : lastProduct.previous,
                    platformProductId: this.appInfoConfig.product,
                });
            }
        });
    }
}
